import React, { Fragment, useEffect, useRef, useState } from "react";
import { Btn } from "../../../../AbstractElements";
import {
  AddPayments,
  Apply,
  ApplyCoupon,
  Cancel,
  Paid,
  Payment,
  PaymentDetail,
  Print,
  ThermalPrint,
  share,
} from "../../../../Constant";
import ItemDescription from "./ItemDescription";
import { Col, Label } from "reactstrap";
import { useReactToPrint } from "react-to-print";
import { useLocation, useNavigate } from "react-router";
import Transparentspinner from "../../../Common/loader/Transparentspinner";
import {
  getGeneratePayment,
  getInvoiceDetail,
  getMakePayment,
  getShareApi,
  postCoupon,
  postMakePayment,
} from "../../../../CommonURL";
import {
  getDataWithToken,
  getMasterDataToken,
  postDataWithToken,
  PostMasterDataToken,
  postMasterToken,
} from "../../../../Utils/restUtils";
import { toast } from "react-toastify";
import CopyLink from "../../../../assets/icons/copy-link.svg";
import Popup from "../../../Common/Popup/Popup";
import PaymentFormPopUp from "../../../Billing/invoice/PaymentForm";
import SweetAlert from "sweetalert2";

const PrintComponent = () => {
  const location = useLocation();
  const searchParams = location.search;
  const params = new URLSearchParams(searchParams);
  const userId = params.get("order_id");
  const navigate = useNavigate();
  const componentRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [invoiceDetail, setInvoiceDetail] = useState({});
  const [statusColor, setStatusColor] = useState("");
  const [couponModal, setCouponModal] = useState(false);
  const [shareModal, setShareModal] = useState(false);
  const [shareUrl, setShareUrl] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const [appURl,setAppUrl]=useState("")
  const [discountAmount, setDiscountAmount] = useState(null);
  const [finalTotal, setFinalTotal] = useState(null);
  const [originalTotal, setOriginalTotal] = useState(null);
  const [orderId, setOrderId] = useState("");

  useEffect(() => {
    getInvoiceData();
  }, []);

  const getInvoiceData = async () => {
    setLoading(true);
    const data = await getDataWithToken(
      getInvoiceDetail + `?order_id=${userId}`,
    );
    // If coupon already applied
    if (data?.data?.applied_coupon_code) {
      setCouponCode(data.data.applied_coupon_code);
      setDiscountAmount(data.data.discountAmount);
      setFinalTotal(data.data.invoiceTotal);
    }
    setOriginalTotal(data?.data?.order_total);
    setOrderId(data?.data?.order_id);
    setAppUrl(data?.data?.app_url)
    setInvoiceDetail(data?.data);
    if (data?.data?.payment_status === "pending") {
      setStatusColor("#dc0808");
    } else if (data?.data?.payment_status === "paid") {
      setStatusColor("#67c100");
    } else if (data?.data?.payment_status === "paschal") {
      setStatusColor("#e56809");
    } else {
      setStatusColor("#5F0F40");
    }
    setLoading(false);
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const redirectToPayment = async () => {
    setLoading(true);
    setModal(!modal);
    setLoading(false);
  };
  const applyCoupon = async () => {
    if (!couponCode) {
      toast.error("Please enter coupon code");
      return;
    }

    const totalAmount = invoiceDetail?.order_total;

    if (!totalAmount) {
      toast.error("Total amount not found");
      return;
    }

    setLoading(true);

    try {
      const response = await getMasterDataToken(
        postCoupon + `?coupon_code=${couponCode}&price=${totalAmount}`,
        {}, // required empty body
      );

      if (response?.data?.status === true) {
        setLoading(true)
        toast.success("Coupon Applied Successfully!");

        const res = response.data.data;

        setDiscountAmount(res.discountAmount);
        setFinalTotal(res.invoiceTotal);

        setInvoiceDetail((prev) => ({
          ...prev,
          order_total: res.invoiceTotal,
        }));

        setCouponModal(false);
      } else {
        toast.error(response?.data?.message || "Failed to apply coupon");
      }
    } catch (error) {
      toast.error("Failed to apply coupon");
    }

    setLoading(false);
  };

  const removeCoupon = () => {
    setCouponCode("");
    setDiscountAmount(null);
    setFinalTotal(null);

    setInvoiceDetail((prev) => ({
      ...prev,
      order_total: originalTotal,
    }));

    toast.success("Coupon Removed");
    setCouponModal(false);
  };
  const handleCancel = () => {
    setCouponCode("")
    setCouponModal(false); 
  };
  const handleShare = async () => {
    setLoading(true);
    try {
      const response = await getMasterDataToken(
        getShareApi + `?order_id=${orderId}`,
      );

      if (response?.data?.status === true) {
        const url = `${appURl}/invoice?order_id=${response.data.data}`;
        setShareUrl(url);
        setShareModal(true);
      }
    } catch (error) {
      toast.error("Failed to share invoice");
    }
    setLoading(false);
  };

  // const MakePayment = () => {
  //     SweetAlert.fire({
  //         title: 'Are you sure?',
  //         text: 'Do you want to make payment?',
  //         icon: 'warning',
  //         showCancelButton: true,
  //         confirmButtonText: 'Ok',
  //         cancelButtonText: 'cancel',
  //         reverseButtons: true
  //     }).then(async (result) => {
  //         setLoading(true);
  //         if (result.value) {
  //             const paymentRes = { order_id: userId, }
  //             const payment = await postDataWithToken(postMakePayment, paymentRes);
  //             if (payment.data.message === "payment successful") {
  //                 SweetAlert.fire(
  //                     'Paid!',
  //                     'Account is Paid.',
  //                     'success'
  //                 );
  //                 getInvoiceData();
  //             } else {
  //                 navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
  //                 setLoading(false);
  //             }
  //         }
  //         setLoading(false);
  //     });
  // };

  // const shareApi = async () => {
  //     const responce = await getDataWithToken(getShareApi + `?order_id=${userId}`);
  //     if (responce.status === true) {
  //         navigate(`/invoice?order_id=${responce.data}`);
  //     }
  // };

  return (
    <Fragment>
      {loading && <Transparentspinner />}
      <ItemDescription
        ref={componentRef}
        invoiceDetail={invoiceDetail}
        statusColor={statusColor}
        setLoading={setLoading}
        finalTotal={finalTotal}
        discountAmount={discountAmount}
        removeCoupon={removeCoupon}
      />

      <Col sm="12" className="text-center my-3">
        {invoiceDetail?.payment_status !== "paid" &&  discountAmount === null &&(
          <Btn
            attrBtn={{
              color: "secondary",
              className: "me-2",
              onClick: () => setCouponModal(true),
            }}
          >
            {ApplyCoupon}
          </Btn>
        )}
        <Btn
          attrBtn={{
            color: "primary",
            className: "me-2",
            onClick: handlePrint,
          }}
        >
          {Print}
        </Btn>
        {invoiceDetail?.payment_status !== "paid" && (
          <Btn
            attrBtn={{
              color: "secondary",
              className: "me-2",
              onClick: redirectToPayment,
            }}
            style
          >
            {AddPayments}
          </Btn>
        )}
        <Btn
          attrBtn={{
            color: "secondary",
            className: "me-2",
            onClick: handleShare,
          }}
        >
          Share
        </Btn>
      </Col>
      <Popup
        size="lg"
        isOpen={modal}
        title={Payment}
        toggler={() => setModal(false)}
      >
        <PaymentFormPopUp
          discountAmount={discountAmount}
          finalTotal={finalTotal}
          invoiceDetail={invoiceDetail}
          orderId={userId}
          setModal={setModal}
        />
      </Popup>
      <Popup
        size="md"
        isOpen={couponModal}
        title="Apply Coupon"
        toggler={() => setCouponModal(false)}
      >
        <div className="p-3">
          <Label>Coupon Code</Label>
          <input
            type="text"
            className="form-control mb-3"
            placeholder="Enter coupon code"
            value={couponCode}
            onChange={(e) => setCouponCode(e.target.value)}
          />

          <Btn
            attrBtn={{
              color: "primary",
              className: "me-2",
              onClick: applyCoupon,
            }}
          >
            {Apply}
          </Btn>

          <button className="btn btn-secondary me-2" onClick={handleCancel}>
            {Cancel}
          </button>

          
        </div>
      </Popup>
      <Popup
        size="sm"
        isOpen={shareModal}
        title="Share"
        toggler={() => setShareModal(false)}
      >
        <div className="p-3">
          <Label>Share Link</Label>

          <div className="d-flex gap-2 align-items-center border rounded p-2">
            <input
              type="text"
              className="form-control"
              value={shareUrl}
              readOnly
            />
            <img
              src={CopyLink}
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigator.clipboard.writeText(shareUrl);
                toast.success("Link copied!");
              }}
            />
          </div>
        </div>
      </Popup>
    </Fragment>
  );
};

export default PrintComponent;
